import React, { Component } from "react";
import { Link } from "react-router-dom";
import FooterLayout from "../../layouts/footer/footer";
import store from "../../store";
import "./sidebar-categories.scss";

interface SidebarCategoriesProp {}

interface SidebarCategoriesState {
  categories: any[];
}

class SidebarCategories extends Component<
  SidebarCategoriesProp,
  SidebarCategoriesState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      categories: store.getState().categories || [],
    };
  }

  toggleCategory = (category: any) => {
    this.setState((prevState) => ({
      categories: prevState.categories.map((cat) =>
        cat.id === category.id ? { ...cat, show: !cat.show } : cat
      ),
    }));
  };

  closeSidebar = () => {
    store.dispatch({
      type: "sidebarOpen",
      value: false,
    });
    document.body.classList.remove("no-scroll");
  };

  render() {
    return (
      <div className='sidebar-categories'>
        <div className='black-layer' onClick={() => this.closeSidebar()}></div>
        <div className='sidebar-background'></div>

        <div className='sidebar-container'>
          <div className='sidebar-top'>
            <div className='logo section'>
              <Link
                to='/'
                className='logo-text'
                onClick={() => this.closeSidebar()}>
                <img
                  src='/logo.png'
                  alt='logo'
                  className='logo-img'
                  width='50'
                />
              </Link>
            </div>
            <div className='close-section' onClick={() => this.closeSidebar()}>
              <i className='icon icon-cross'></i>
            </div>
          </div>
          <div className='sidebar-content'>
            <div className='link'>
              {this.state.categories
                ?.filter((c) => c.active)
                .map((category) => {
                  return (
                    <div
                      className='sidebar-category-item'
                      key={"sidebar-category-item-" + category.id}>
                      <div className='category'>
                        <div
                          className='category-name'
                          onClick={() => {
                            this.toggleCategory(category);
                          }}>
                          <div>{category.name}</div>
                        </div>
                      </div>

                      {category.show ? (
                        <Link
                          className='shop-now category-link'
                          to={"/category/" + category.slug}
                          onClick={() => this.closeSidebar()}>
                          <div className='sub-category'>
                            <div>Бүтээгдэхүүнүүд</div>
                          </div>
                        </Link>
                      ) : null}

                      {category.show &&
                        category.subCategories.map((sub: any) => {
                          return (
                            <Link
                              to={"/category/" + category.slug + "/" + sub.slug}
                              key={"sidebar-sub-category-" + sub.id}
                              onClick={() => this.closeSidebar()}>
                              <div className='sub-category'>{sub.name}</div>
                            </Link>
                          );
                        })}
                    </div>
                  );
                })}
            </div>
          </div>
          <FooterLayout />
        </div>
      </div>
    );
  }
}

export default SidebarCategories;
